import _ from 'lodash';

const origin = {
  file: {
    name: '',
    url: '',
  },
  fileList: [],
  viewType: 0, // 单文件查看，数组式查看
  show: false,
  defaultIndex:0,
};
export default {
  namespaced: true,
  state: _.cloneDeep(origin),
  mutations: {
    close(state: any, value: boolean) {
      state.show = value;
    },
    setFile(state: any, file: any) {
      if (_.isString(file)) {
        state.file.url = file;
      } else {
        // 如果是对象
        state.file.url = file.url;
        state.file.name = file.name;
      }


      state.viewType = 0;

      state.show = true;

    },
    setFileList(state: any, content) {
      let fileList=content.list;
      state.defaultIndex=content.index;
      state.fileList = [];
      for (let i = 0; i < fileList.length; i++) {
        if (_.isString(fileList[i])) {
          state.fileList.push({name: 'index' + i, url: fileList[i]});
        } else {
          state.fileList.push(_.clone(fileList[i]));
        }
      }
      state.viewType = 1;
      if (!state.show) {
        state.show = true;
      }
    },

  },
  actions: {},
};
